import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { monthlyViewType } from 'src/app/config/monthly-view-type';
import { AddStaffService } from 'src/app/on-boarding/components/add-staff/services/add-staff.service';
import { ManageUsersAccountService } from 'src/app/services/manage-users-account.service';
import { AddStaffDialogComponent } from '../add-staff-dialog/add-staff-dialog.component';

@Component({
  selector: 'app-smart-toolbar',
  templateUrl: './smart-toolbar.component.html',
  styleUrls: ['./smart-toolbar.component.scss']
})
export class SmartToolbarComponent implements OnInit {
  viewTypes: any = monthlyViewType;
  @Output() finishedClicked: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  hideSmartBanner: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public dialog: MatDialog,
    private _addStaffService: AddStaffService,
    private _accountSettings: ManageUsersAccountService
  ) { }

  ngOnInit(): void {
  }
  openStaffPopup() {
    const dialogRef = this.dialog.open(AddStaffDialogComponent, {
      height: '800px',
      width: '1252px',
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this._accountSettings.setClientType(this.viewTypes.hybrid).subscribe(e => {
          this._addStaffService._addedStaff.next('');
          this.finishedClicked.emit(this.viewTypes.hybrid);
        });
      }
    });
  }
}
